module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "rt-breadcrumb",
    attrs: {
      "aria-label": "Breadcrumb",
      "role": "navigation"
    }
  }, [_c('div', {
    ref: "breadcrumbScroll",
    staticClass: "rt-breadcrumb--wrapper"
  }, [_vm._t("default"), _vm._v(" "), (!_vm.$slots.default) ? _c('div', {
    ref: "crumbItemContent",
    staticClass: "rt-breadcrumb--content"
  }, _vm._l((_vm.itemsLimited), function(item, index) {
    return _c('rt-breadcrumb-item', {
      key: index + item.name,
      ref: "rtbreadcrumbitem",
      refInFor: true,
      attrs: {
        "prev-icon-name": item.prevIconName,
        "split-icon-name": _vm.splitIconName,
        "index": index,
        "to": item.path
      },
      on: {
        "on-breadcrumb-click": _vm.breadcrumbClick
      }
    }, [_vm._v("\n        " + _vm._s(item.name) + "\n      ")])
  }), 1) : _vm._e()], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b9d19c1a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-xpc/src/components/breadcrumb/rtBreadcrumb.vue
// module id = 2153
// module chunks = 228